export default "https://static.wetvinfo.com/tv/linux/static/media/chakan_h.png";